import { createColumnHelper } from '@tanstack/react-table'
import { format } from 'date-fns'
import { useMemo } from 'react'
import { REBATE_ENROLLMENT_COLUMNS } from './rebateEnrollmentsColumnInfo'
import { RebateEnrollment } from '../tradespend_api'
import { formatInteger, formatUsd } from 'utils/formatting'

export const useRebateEnrollmentsColumns = () => {
  const columnHelper = createColumnHelper<RebateEnrollment>()

  const columns = useMemo(() => {
    return [
      columnHelper.accessor('tradespend_user_name', {
        header: REBATE_ENROLLMENT_COLUMNS.tradespend_user_name.header,
        size: 200,
      }),
      columnHelper.accessor('company_name', {
        header: REBATE_ENROLLMENT_COLUMNS.company_name.header,
        size: 200,
      }),
      columnHelper.accessor('total_claims', {
        header: REBATE_ENROLLMENT_COLUMNS.total_claims.header,
        size: 120,
        cell: (info) => formatInteger(info.getValue()),
      }),
      columnHelper.accessor('pending_validation_claims', {
        header: REBATE_ENROLLMENT_COLUMNS.pending_validation_claims.header,
        size: 120,
        cell: (info) => formatInteger(info.getValue()),
      }),
      columnHelper.accessor('invalid_claims', {
        header: REBATE_ENROLLMENT_COLUMNS.invalid_claims.header,
        size: 120,
        cell: (info) => formatInteger(info.getValue()),
      }),
      columnHelper.accessor('unpaid_valid_claims', {
        header: REBATE_ENROLLMENT_COLUMNS.unpaid_valid_claims.header,
        size: 120,
        cell: (info) => formatInteger(info.getValue()),
      }),
      columnHelper.accessor('paid_claims', {
        header: REBATE_ENROLLMENT_COLUMNS.paid_claims.header,
        size: 120,
        cell: (info) => formatInteger(info.getValue()),
      }),
      columnHelper.accessor('total_validated_units', {
        header: REBATE_ENROLLMENT_COLUMNS.total_validated_units.header,
        size: 120,
        cell: (info) => {
          const units = info.getValue()
          return units !== null ? units.toFixed(2) : '-'
        },
      }),
      columnHelper.accessor('total_validated_payout', {
        header: REBATE_ENROLLMENT_COLUMNS.total_validated_payout.header,
        size: 120,
        cell: (info) => {
          const amount = info.getValue()
          return amount !== null ? formatUsd(amount) : '-'
        },
      }),
      columnHelper.accessor('created', {
        header: REBATE_ENROLLMENT_COLUMNS.created.header,
        size: 150,
        cell: (info) => format(new Date(info.getValue()), 'MMM d, yyyy'),
      }),
    ]
  }, [])

  return columns
}
